import Box from "@mui/material/Box";
import styled from "@mui/material/styles/styled";
import { toAssetImages } from "src/lib/utils";

export const StyledHorizontalCard = styled(Box)(({ theme }) => ({
  maxHeight: "90px",
  height: "100%",
  margin: "auto",
  borderRadius: ".5rem",
  overflow: "hidden",
  position: "relative",
  transition: "all 250ms ease-in-out",
  background: theme.palette.background.paper,
  border: "1px solid #EBEBF0",
  "&:hover": {
    boxShadow: theme.shadows[2],
    "& .controlBox": {
      display: "flex",
      bottom: 0,
    },
  },
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
}));
export const StyledCard = styled(Box)(({ theme }) => ({
  background: "#FFFFFF",
  border: "1px solid #FBFBFB",
  boxShadow: "0px 5px 22px rgba(0, 0, 0, 0.04)",
  borderRadius: "16px",
  textAlign: "center",
  padding: "60px",
  transition: "box-shadow 0.3s ease-out, transform 0.3s ease-out",
  "&:hover": {
    transform: "translate3d(0,-10px,0)",
    boxShadow: "0px 21px 44px rgba(0, 0, 0, 0.08)",
  },
}));
export const FeaturedImgBox = styled("div", { shouldForwardProp: (props) => props !== "bgImg" })(
  () => ({
    margin: "auto",
    padding: "auto",
    width: "50%",
  }),
);

export const ContentWrapper = styled("div")({
  flex: 1,
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  padding: "1rem",
  "& .title": {
    flex: "1 0 auto",
    margin: 0,
  },
});
